import { GameObjects } from 'phaser';
import { getResolution } from '@/GameUI/Constants';

const { Container, Graphics } = GameObjects;
const { POINTER_OUT, POINTER_OVER, POINTER_DOWN, POINTER_UP } = Phaser.Input.Events;

const ALPHA_REGULAR = 1;
const ALPHA_HOVER = .8;

const BKG_TEXTURE = 'btn_background';

export enum BtnEvent {
	PRESSED = 'EVENT_BTN_PRESSED',
}

class Button extends Container {

	private background;
	private message;
	private isPressing = false;

	constructor(text: string | string[], color: number, width: number, height: number, style: Partial<GameObjects.TextStyle>, ...params: ConstructorParameters<typeof Container>) {
		super(...params);
		this.width = width;
		this.height = height;

		const Background = `${BKG_TEXTURE}_${width}x${height}`;

		if (!this.scene.textures.exists(Background)) {
			const bkg = new Graphics(this.scene);
			bkg.fillStyle(color);
			bkg.fillRoundedRect(0, 0, this.width, this.height, 10);
			bkg.generateTexture(Background, this.width, this.height);
		}

		this.background = new GameObjects.Image(this.scene, 0, 0, Background);
		this.add(this.background);
		style = style ?? {
			align: 'center',
			color: '#FFF',
			fontFamily: 'Arial',
			fontSize: 34 * 2,
			resolution: getResolution(),
		};

		this.message = new GameObjects.Text(this.scene, 0, 0, text, style);
		this.add(this.message);
		Phaser.Display.Align.In.Center(this.message, this.background);

		this.setInteractive(new Phaser.Geom.Rectangle(0, 0, this.width, this.height), Phaser.Geom.Rectangle.Contains);

		this.background.setInteractive(new Phaser.Geom.Rectangle(0, 0, this.width, this.height), Phaser.Geom.Rectangle.Contains).on(POINTER_OUT, () => {
			this.setAlpha(ALPHA_REGULAR);
		}, this).on(POINTER_OVER, () => {
			this.setAlpha(ALPHA_HOVER);
		}, this);

		this.background.on(POINTER_DOWN, () => {
			this.isPressing = true;
		});
		this.background.on(POINTER_UP, () => {
			if (this.isPressing) {
				this.emit(BtnEvent.PRESSED);
			}

			this.isPressing = false;
		});

	}

	setMessage(newText: string) {
		this.message.setText(newText);
		Phaser.Display.Align.In.Center(this.message, this.background);
	}

}

export default Button;
